import {
  getLocalStorage,
  safeClearStorage,
  safeGetStorageItem,
  safeRemoveStorageItem,
  safeSetStorageItem,
} from '../../dashboard/helper/browserStorage';

export const LocalStorage = {
  clearAll() {
    const storage = getLocalStorage();
    return storage ? safeClearStorage(storage) : true;
  },

  get(key) {
    let value = null;
    try {
      const storage = getLocalStorage();
      if (!storage) return null;

      value = safeGetStorageItem(storage, key);
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (error) {
      return value;
    }
  },

  set(key, value) {
    try {
      const storage = getLocalStorage();
      if (!storage) return false;

      const timestampKey = `${key}:ts`;
      const serializedValue =
        typeof value === 'object' ? JSON.stringify(value) : value;

      if (!safeSetStorageItem(storage, key, serializedValue)) {
        return false;
      }

      if (!safeSetStorageItem(storage, timestampKey, Date.now().toString())) {
        return false;
      }

      return true;
    } catch {
      return false;
    }
  },

  setFlag(store, accountId, key, expiry = 24 * 60 * 60 * 1000) {
    try {
      const storage = getLocalStorage();
      if (!storage) return false;

      const storeName = accountId ? `${store}::${accountId}` : store;
      if (!storeName) return false;

      const rawValue = safeGetStorageItem(storage, storeName);
      const parsedValue = rawValue ? JSON.parse(rawValue) : {};

      parsedValue[key] = Date.now() + expiry;

      return safeSetStorageItem(
        storage,
        storeName,
        JSON.stringify(parsedValue)
      );
    } catch {
      return false;
    }
  },

  getFlag(store, accountId, key) {
    try {
      const storage = getLocalStorage();
      if (!storage) return false;

      const storeName = store ? `${store}::${accountId}` : store;
      if (!storeName) return false;

      const rawValue = safeGetStorageItem(storage, storeName);
      const parsedValue = rawValue ? JSON.parse(rawValue) : {};

      return Boolean(parsedValue[key] && parsedValue[key] > Date.now());
    } catch {
      return false;
    }
  },

  remove(key) {
    try {
      const storage = getLocalStorage();
      if (!storage) return false;

      safeRemoveStorageItem(storage, key);
      safeRemoveStorageItem(storage, `${key}:ts`);
      return true;
    } catch {
      return false;
    }
  },

  updateJsonStore(storeName, key, value) {
    try {
      const storedValue = this.get(storeName) || {};
      storedValue[key] = value;
      return this.set(storeName, storedValue);
    } catch {
      return false;
    }
  },

  getFromJsonStore(storeName, key) {
    try {
      const storedValue = this.get(storeName) || {};
      return storedValue[key] || null;
    } catch {
      return null;
    }
  },

  deleteFromJsonStore(storeName, key) {
    try {
      const storedValue = this.get(storeName);
      if (storedValue && key in storedValue) {
        delete storedValue[key];
        return this.set(storeName, storedValue);
      }
      return false;
    } catch {
      return false;
    }
  },
};
